export default theme => ({
  offsetMeter: {
    position: 'absolute'
  },
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    paddingTop: '50vh',
    paddingBottom: '50vh',
  },
  container: {
    [theme.breakpoints.up('lg')]: {
      width: 600
    }
  },
  error: {
    marginBottom: theme.spacing.unit * 3
  },
  spacer: {
    height: theme.spacing.unit * 15
  }
});



// WEBPACK FOOTER //
// ./src/components/ScrollForm/Container/styles.js